import React from 'react';
import { BaasicModalTemplate } from 'themes/components';
import { observer } from 'mobx-react';

function BaasicModal(props) {
	return <BaasicModalTemplate {...props} />;
}

BaasicModal.defaultProps = {
	className: 'ReactModal__Content'
}

export default observer(BaasicModal);
